import React from 'react';

import './Info.scss';

type Props = {
  children: React.ReactNode;
  type?: 'subtle' | 'info' | 'success' | 'warning' | 'danger';
  className?: string;
};

const Info = ({ children, type, className }: Props) => (
  <div className={`wp-info-box ${type} ${className}`}>{children}</div>
);

export default Info;
